<script>
import ContractDetailService from "@/services/ContractDetailService";
import PaymentPeriods from "./components/PaymentPeriods.vue";
import dayjs from "dayjs";

export default {
    components: { PaymentPeriods },
    props: {},
    data() {
        return {
            loading: true,
            cds: [],
            year: null,
            years: {}
        };
    },
    async created() {
        this.year = dayjs().format("YYYY");
        this.$watch("year", n => {
            this.fetchData();
        });
        await this.fetchData();
        this.loading = false;
    },
    methods: {
        async fetchData() {
            try {
                const {
                    data
                } = await ContractDetailService.GET_paymentOverview(this.year);
                this.cds = data.data;
                this.years = data.meta.years;
            } catch (e) {
                console.log("E:fetchData", e);
            }
        }
    }
};
</script>

<template>
    <div class="contract-payments">
        <base-header class="pb-1" type="">
            <bread-bag> </bread-bag>
        </base-header>

        <div class="container-fluid">
            <div class="row card-wrapper">
                <div class="col-12">
                    <div class="row">
                        <div class="col-3">
                            <FormulateInput
                                type="multiselect"
                                :options="years"
                                v-model="year"
                                :label="$t('contract_detail.accounting_year')"
                            />
                        </div>
                        <div class="col-9 text-right" style="margin-top: 30px;">
                            <a
                                target="_blank"
                                :href="
                                    `/v1/contract-details/payment-overview/${year}?csv=1`
                                "
                                class="btn btn-primary"
                                ><i class="far fa-file-excel"></i>
                                {{ $t("personal_multiview.export_as_csv") }}</a
                            >
                        </div>
                    </div>
                    <card body-classes="px-0">
                        <v-loader :loading="loading" v-if="loading" />
                        <template v-else-if="cds.length > 0">
                            <v-table class="table table-mg table-sm">
                                <v-thead>
                                    <v-tr>
                                        <v-th>{{
                                            $t("contract_detail.tbl_hdr_ID")
                                        }}</v-th>
                                        <v-th>{{
                                            $t(
                                                "contract_detail.tbl_hdr_customer"
                                            )
                                        }}</v-th>
                                        <v-th class="text-center">{{
                                            $t(
                                                "contract_detail.tbl_hdr_asset_type"
                                            )
                                        }}</v-th>
                                        <v-th>{{
                                            $t(
                                                "contract_detail.tbl_hdr_contract_type"
                                            )
                                        }}</v-th>
                                        <v-th>{{
                                            $t(
                                                "contract_detail.tbl_hdr_payment_periods"
                                            )
                                        }}</v-th>
                                    </v-tr>
                                </v-thead>
                                <v-tbody>
                                    <v-tr v-for="(p, idx) in cds" :key="idx">
                                        <v-td>#{{ p.contract.id }}</v-td>
                                        <v-td>{{ p.customer.name }}</v-td>
                                        <v-td class="text-center"
                                            ><i
                                                class="far"
                                                :class="
                                                    p.contract.asset_type.icon
                                                "
                                            ></i>
                                        </v-td>
                                        <v-td>{{ p.contract.type_name }}</v-td>

                                        <v-td style="min-width: 44%">
                                            <payment-periods :periods="p.cds" />
                                        </v-td>
                                    </v-tr>
                                </v-tbody>
                            </v-table>
                        </template>
                        <template v-else>
                            <div class="my-2 alert alert-warning">
                                {{ $t("contract.no_data_found") }}
                            </div>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
